module.exports = __webpack_public_path__ + "img/H3.87c4f4c1.png";